import ImageLoader from 'components/ImageLoader'
import { useMemo } from 'react'
import { useGetGiftsListQuery } from 'store/api/yay/gifts'

const PostCallGiftSummary = ({
  gifts,
}: {
  gifts: Array<{ id: number; quantity: number }>
}) => {
  const { data: giftsListData, isLoading, isSuccess } = useGetGiftsListQuery({})
  const giftsDict = useMemo(() => {
    const dict = {}
    if (giftsListData) {
      giftsListData.gifts?.forEach((gift) => {
        dict[gift.id] = gift
      })
    }
    return dict
  }, [giftsListData])

  return (
    <div className="PostCallGiftSummary">
      {isSuccess && Object.keys(giftsDict).length > 0 && (
        <ul className="PostCallGiftSummary__ul">
          {gifts.map((receivedGiftInfo) => {
            return (
              <li
                key={receivedGiftInfo.id}
                className="PostCallGiftSummary__ul__li"
                title={giftsDict[receivedGiftInfo.id]?.title}
              >
                <ImageLoader
                  url={giftsDict[receivedGiftInfo.id]?.icon_thumbnail}
                />
                {receivedGiftInfo.quantity}
              </li>
            )
          })}
        </ul>
      )}
    </div>
  )
}

export default PostCallGiftSummary
